import './blogpost.css';
import Header from "~/layouts/components/Header";
import Footer from "~/layouts/components/Footer";
import {ScrollToTopButton} from "~/components";

function BlogPostLayout({children}) {
    return (
        <div>
            <Header />
            <div className="pb-5" style={{ backgroundColor: '#fff' }}>
                {children}
            </div>
            <Footer/>
            <ScrollToTopButton/>
        </div>
    )
}

export default BlogPostLayout;